
const InternetOfThings = () => {
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_130_5053)">
        <path
          d="M17.3934 8.59963L18.4277 7.17838C16.7681 5.97047 14.8028 5.33203 12.7441 5.33203C10.6855 5.33203 8.72016 5.97047 7.06055 7.17838L8.0949 8.59963C9.45199 7.61191 11.0597 7.08984 12.7441 7.08984C14.4286 7.08984 16.0363 7.61191 17.3934 8.59963Z"
          fill="#5CACD5"
        />
        <path
          d="M4.99414 4.33395L6.0285 5.7552C7.98904 4.32838 10.3113 3.57422 12.7444 3.57422C15.1774 3.57422 17.4997 4.32838 19.4602 5.7552L20.4946 4.33395C18.2316 2.68693 15.5516 1.81641 12.7444 1.81641C9.93717 1.81641 7.25721 2.68693 4.99414 4.33395ZM8.09516 21.4004L7.0608 22.8216C8.72041 24.0295 10.6858 24.668 12.7444 24.668C14.803 24.668 16.7684 24.0295 18.428 22.8216L17.3936 21.4004C16.0365 22.3881 14.4288 22.9102 12.7444 22.9102C11.0599 22.9102 9.45225 22.3881 8.09516 21.4004Z"
          fill="#FF1818"
        />
        <path
          d="M12.7441 26.4258C10.3111 26.4258 7.98879 25.6716 6.0283 24.2448L4.99395 25.6661C7.25695 27.3131 9.93691 28.1836 12.7441 28.1836C15.5514 28.1836 18.2313 27.3131 20.4944 25.6661L19.46 24.2448C17.4995 25.6716 15.1772 26.4258 12.7441 26.4258ZM20.9221 7.93945V11.974H23.4438V22.0605H27.4784V11.974H30V7.93945H20.9221ZM0 7.93945H4.03459V22.0605H0V7.93945ZM12.7441 21.0519C16.0865 21.0519 18.7961 18.3424 18.7961 15C18.7961 11.6576 16.0865 8.94809 12.7441 8.94809C9.40178 8.94809 6.69223 11.6576 6.69223 15C6.69223 18.3424 9.40178 21.0519 12.7441 21.0519ZM12.7441 12.9827C13.8582 12.9827 14.7615 13.8858 14.7615 15C14.7615 16.1142 13.8583 17.0173 12.7441 17.0173C11.63 17.0173 10.7268 16.1142 10.7268 15C10.7268 13.8858 11.63 12.9827 12.7441 12.9827Z"
          fill="#FF1818"
        />
      </g>
      <defs>
        <clipPath id="clip0_130_5053">
          <rect width="30" height="30" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default InternetOfThings;
